import { useEffect, useState } from 'react';

// True while the visitor's phone or computer is set to dark mode. Updates live
// when they switch, so canvas and map colours can follow the CSS
// (prefers-color-scheme) without a reload.
const DARK_QUERY = '(prefers-color-scheme: dark)';

export const prefersDarkNow = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(DARK_QUERY).matches;

export const usePrefersDark = () => {
  const [dark, setDark] = useState(prefersDarkNow);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(DARK_QUERY);
    const update = () => setDark(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
      return () => mq.removeEventListener('change', update);
    }
    mq.addListener(update);
    return () => mq.removeListener(update);
  }, []);
  return dark;
};
